import { formatDate } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import { FormatDataTableGlobal, TableOneSearch } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { Chart } from 'chart.js';
import { costEffecctiveness } from 'src/app/web/interfaces/project/cost-effectiveness/costEffectiveness';
import { listInfoAsign } from 'src/app/web/interfaces/project/cost-effectiveness/listInfoAsign';
import { listInfoGrafit } from 'src/app/web/interfaces/project/cost-effectiveness/listInfoGrafit';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';
import { FormatChatsOptionLineGlobal } from 'src/app/web/util/formatChart';


@Component({
  selector: 'app-cost-effectiveness',
  templateUrl: './cost-effectiveness.component.html',
  styleUrls: ['./cost-effectiveness.component.scss']
})


export class CostEffectivenessComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  idProject:number;
  dtOptions: DataTables.Settings = {};
  title = 'datos';
  listdate = [];
  listmonto = [];

  costEffecctiveness : costEffecctiveness = {}as costEffecctiveness;
  listInfoAsign = [];
  listInfoGrafit : listInfoGrafit[] = [];
  arregloFechas = [];
  arregloMonto = [];
  grafico;
  rangoFechas = [];
  nuevoMontos = [];
  dates: FormGroup;
  state =1;
  test =true;


  constructor(private apiService: ApiServiceProject,
              private router: Router,
              private fb: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private spinner: NgxSpinnerService,
              private errorService:ErrorService) { 
   this.activatedRoute.params.subscribe(params => {
     this.idProject = params['id'];
     this.title = params['title'];
    })
  }

  ngOnInit(): void {
    this.spinner.show();

    this.dates = this.fb.group({
      start_date:[''],
      end_date:[''],
    })



    this.dtOptions = FormatDataTableGlobal();

    this.apiService.getService('project-cost-effectiveness?id_project='+this.idProject)
    .subscribe({
      next: (rs: any) => {
        if (rs.code == null) {
          this.costEffecctiveness = rs;
          this.listInfoAsign = rs.listInfoAsign;
          this.listInfoGrafit = rs.listInfoGrafit;
          this.listInfoGrafit.map((d)=>{
            this.listdate.push(d.date);
            let numero = d.amount
            numero = numero.replace('$','');
            numero = numero.replace('.','');
            numero = numero.replace(',','.');
            this.listmonto.push(Math.round(Number(numero)));
          })
          this.spinner.hide();
          this.listInfoGrafit.map((dato)=>{
            this.arregloFechas.push(dato.date);
            let monto = dato.amount
            monto = monto.replace('$','');
            monto = monto.replace('.','');
            this.arregloMonto.push(Math.round(Number(monto)));
            
          })
          this.grafico = new Chart('chart-line',  {
          type: 'line',
          data: this.chart1.data,
          options: this.chart1.options
         });

          this.rerender();
          // Swal.fire('Fechas','Seleccione un rango de fechas para visualizar informacion','info')
        } else {
          this.spinner.hide();
          Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }


  chart1 = {
    data :{
      labels: this.arregloFechas,
      datasets: [
      {
        label: 'Monto',
        data: this.arregloMonto,
        backgroundColor: 'transparent',
        borderColor: '#36a2eb',
        borderWidth: 2,
      }
    ]
    },
    options: FormatChatsOptionLineGlobal()
  };

  formSumbmit(){
    
  this.state = 2


    this.test = false;
    if (this.dates.value.start_date=== '') {
      this.spinner.hide();

      Swal.fire({title: 'Debe ingresar una fecha de inicio' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.dates.value.end_date === '') {
      this.spinner.hide();

      Swal.fire({title: 'Debe ingresar una fecha de termino' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    let startDate = moment(this.dates.value.start_date).format("DD-MM-YYYY");

    let endDate = moment(this.dates.value.end_date).format("DD-MM-YYYY");
  


  //  let buscar= this.arregloFechas.includes(startDate)
    let contador =0 ;
   this.arregloFechas.map((fecha)=>{

    if(fecha>=startDate && fecha<=endDate){
      this.rangoFechas.push(fecha)
      this.nuevoMontos.push(this.arregloMonto[contador])
    }
    
    
    contador = contador +1;
   })


  this.chart1 = {
    data :{
      labels: this.rangoFechas,
      datasets: [
      {
        label: 'Monto',
        data: this.nuevoMontos,
        backgroundColor: 'transparent',
        borderColor: '#36a2eb',
        borderWidth: 2,
      }
    ]
    },
    options: FormatChatsOptionLineGlobal()
  };
  this.grafico.destroy()
  new Chart('chart-line',  {
        type: 'line',
        data: this.chart1.data,
        options: this.chart1.options
      });
  this.rangoFechas = [];
  this.nuevoMontos = [];

  }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }


}
